"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfillers = getFulfillers;
var _consts = require("../utils/consts");
var FulfillerIdentity = require('cimpress-fulfiller-identity');
function getFulfillers(token, env, options) {
  var fulfillerIdentity = env === _consts.EnvironmentKey.Production ? new FulfillerIdentity('Bearer ' + token, {
    timeout: 8000
  }) : env === _consts.EnvironmentKey.Staging ? new FulfillerIdentity('Bearer ' + token, {
    timeout: 8000,
    url: "https://fulfilleridentity.staging.trdlnk.cimpress.io"
  }) : null;
  if (fulfillerIdentity === null) {
    throw new Error("Incorrect environment provided: \"".concat(env, "\""));
  }
  return fulfillerIdentity.getFulfillers(options);
}